import * as React from 'react'
import { Link } from 'react-router-dom'
import { IRiderSearchObject } from '../../../types/rider'
import { IProgramServiceMembership } from '../../../types/membership'
import ImageView from '../../ui/ImageView'
import * as moment from 'moment'

interface IRiderListItemProps {
  onChooseRider: (rider: IRiderSearchObject) => void
  rider: IRiderSearchObject
}

interface IRiderListItemState {}

class ListItem extends React.Component<IRiderListItemProps, IRiderListItemState> {
  private linkRef: any

  public render() {
    const { rider } = this.props

    const date = rider.birthDate ? rider.birthDate.split('T')[0] : null
    const birthDate = date
      ? moment(date)
          .format('MMMM DD, YYYY')
          .toString()
      : 'N/A'
    return (
      <div className='list-item flex mb2 cursor--pointer' onClick={this.handleClick} key={rider.id}>
        {/* Declare name of Avatar */}
        <ImageView
          entityId={rider.id}
          name={rider.firstName + ' ' + rider.lastName}
          isRounded={true}
          width='50px'
          height='50px'
        />
        {/* Declare name of Avatar */}
        <div className='flex-auto ml1'>
          <p className='m0 font-dark-grey'>
            <Link to={`/trips/recent/${rider.id}`} ref={this.attachRef}>
              {rider.firstName + ' ' + rider.lastName}
            </Link>
          </p>
          {rider.phone && <p className='ml0 mr0 mt02 mb02 font-small'>{rider.phone}</p>}
          <div className=''>
            {rider.serviceMemberships.map((membership: IProgramServiceMembership, key: number) => (
              <span
                className='service-name p02 mr1 uppercase font-micro weight-600 font-blue-grey border-light-grey2 inline-block'
                key={key}
              >
                {membership.service && membership.service.name}
              </span>
            ))}
          </div>
        </div>
        <div className=''>
          <p className='m0 uppercase font-small weight-300 font-dark-grey'>{birthDate}</p>
        </div>
      </div>
    )
  }

  private attachRef = (elm: any) => {
    this.linkRef = elm
  }

  private handleClick = (e: React.MouseEvent<HTMLElement>) => {
    this.props.onChooseRider(this.props.rider)
    this.linkRef.handleClick(e)
  }
}

interface IRiderListProps {
  onChooseRider: (rider: IRiderSearchObject) => any
  riders: IRiderSearchObject[]
  isSearchResult: boolean
  isFetching: boolean
}

const RiderList = (props: IRiderListProps) => {
  const { onChooseRider, isSearchResult, isFetching } = props
  let listMarkup = props.riders.map(rider => {
    return <ListItem rider={rider} onChooseRider={onChooseRider} key={'rider-search-' + rider.id} />
  })

  if (!isSearchResult || isFetching) {
    return null
  }

  if (isSearchResult && props.riders && props.riders.length === 0) {
    listMarkup = [
      <div key='empty-riders' className='rider-list-empty'>
        <p>No results</p>
        <p>You may want to try</p>
        <ul>
          <li>Different words</li>
          <li>Check of typos</li>
        </ul>
        <p>or</p>
      </div>
    ]
  }

  return (
    <div className='rider-list pl3 pt2 pr2' style={{ height: 'calc(100vh - 12rem)', overflowY: 'scroll' }}>
      {listMarkup}
      <div className='create-rider'>
        <Link to='/riders/create/profile'>Create new Rider</Link>
      </div>
    </div>
  )
}

export default RiderList



// WEBPACK FOOTER //
// ./src/components/trips/riders/RiderList.tsx